import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useFetchIncome from "../../hook/useFtechIncome";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Current Income",
  "Spouse's Income",
  "Business Interests Divorce",
];

export default function IncomeInformation() {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Income Information");
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  // Use the income hook
  const {
    incomeNames,
    selectedIncome,
    getIncomeNames,
    handleIncomeSelect,
    getIncomeList
  } = useFetchIncome();

  console.log("Income Names", incomeNames);

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading
  );

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  
  );
  
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );



  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

 
 
  const tableDataObj = {
    "Current Income": tableData.currentIncomeData,
    "Spouse's Income": tableData.spousesIncomeData,
    "Business Interests Divorce": tableData.businessInterestsDivorceData,
  };
  
  const handleFormDataUpdate = (formData) => {
    const Payload = {
      "Income Source": formData && formData["Income Name"],
      "Frequency": formData && formData["Frequency of Pay Periods"],
      "Monthly Amount": formData && formData["Gross Monthly Wages"],

    };
  
    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };
  
  
  const currentIncomeTable = [{ title: "Current Income", key: 1 }];
  const spouseIncomeTable = [{ title: "Spouse's Income", key: 2 }];
  const businessInterestTable = [{ title: "Business Interests", key: 3 , backendName: "Business Interests Divorce"}];

  const AddContact = () => history.push("/client/plan");
  const AddDocument = () => history.push("/organizer/important-document");
  const AddIncome = () => history.push("/income");

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Income Information</h2>
            <ToolTipCreator name={"Divorce_Income_Information"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      
      <div className="child-title-container">
        <h2 className="child-title">Current Income</h2>
      </div>
      {currentIncomeTable.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          createAttributes={createAttributes}
          onClick={AddIncome}
          handleFormDataUpdate={handleFormDataUpdate}
          options={incomeNames}
          onSelect={handleIncomeSelect}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <div className="child-title-container">
        <h2 className="child-title">Spouse's Income</h2>
      </div>
      {spouseIncomeTable.map((table) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          createAttributes={createAttributes}
          onClick={AddIncome}
          handleFormDataUpdate={handleFormDataUpdate}
          options={incomeNames} 
          // onSelect={handleIncomeSelect} // Handle income selection

        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <div className="child-title-container">
        <h2 className="child-title">Business Interests</h2>
      </div>
      {businessInterestTable.map((table) => {
         const moduleTitle = table.backendName || table.title;
         return (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          createAttributes={createAttributes}
          onClick={() => showModal(moduleTitle)}
        >
          <Table
            columns={AllColumnsData[moduleTitle]}
            dataSource={tableDataObj[moduleTitle]}
          />
        </CollapseableTable>
         );
})}
      
      <CustomModal
        show={isModalVisible}
        fields={attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
}